<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START FOOTER 1 w/ COMPANY DESCRIPTION AND 4 COLS ------- -->
<footer class="footer" style="{style(block)}">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 mb-5 mb-lg-0">
        <img class="d-block" src="{image(block, 'logo', [null, 50])}" alt="">
        <!-- <p class="mb-4 pb-2"> -->
        <!--     The next generation of design systems. -->
        <!-- </p> -->
        <!-- <a href="javascript:;" target="_blank" class="text-secondary me-xl-4 me-3"> -->
        <!--   <span class="text-lg fab fa-facebook"></span> -->
        <!-- </a> -->
        <!-- <a href="javascript:;" target="_blank" class="text-secondary me-xl-4 me-3"> -->
        <!--   <span class="text-lg fab fa-twitter"></span> -->
        <!-- </a> -->
        <!-- <a href="javascript:;" target="_blank" class="text-secondary me-xl-4 me-3"> -->
        <!--   <span class="text-lg fab fa-instagram"></span> -->
        <!-- </a> -->
        <!-- <a href="javascript:;" target="_blank" class="text-secondary me-xl-4 me-3"> -->
        <!--   <span class="text-lg fab fa-pinterest"></span> -->
        <!-- </a> -->
        <!-- <a href="javascript:;" target="_blank" class="text-secondary me-xl-4 me-3"> -->
        <!--   <span class="text-lg fab fa-github"></span> -->
        <!-- </a> -->
      </div>
      {#each blocklist(block, 'columns') as item}
      <div class="col-md-4 col-lg-3 ms-lg-auto mb-md-0 mb-4">
        <h6 class="text-sm">{text(item, 'title')}</h6>
        <div>
          {@html richtext(item, 'body')}
        </div>
      </div>
      {/each}
    </div>
    <hr class="horizontal dark mt-lg-5 mt-4 mb-sm-4 mb-1">
    <p class="text-sm text-secondary text-center">
      <span class="">© All rights reserved. Made by</span>
      <a class="small nav-link-style nav-link-light text-nowrap" href="https://keycommunication.lt" target="_blank" rel="noopener">key | communication</a>
    </p>
  </div>
</footer>
<!-- -------- END FOOTER 1 w/ COMPANY DESCRIPTION AND 4 COLS ------- -->
